import {
  OctahedronGeometry,
  MeshLambertMaterial,
  Mesh
} from 'three';

import * as satellite from "satellite.js";

import { Util } from "./Util";

import { EARTH_RADIUS_KM } from "./constants";

export class SatelliteManager {

    constructor(widget, gv, tleFile, followSatellite = -1, satSize = 100){
  
      this.world = gv.world;
  
      this.world.objectLat('lat').objectLng('lng').objectAltitude('alt').objectLabel('name');
  
      this.followSatellite = followSatellite;
  
      this.satGeometry = new OctahedronGeometry(satSize * this.world.getGlobeRadius() / EARTH_RADIUS_KM / 2, 0);
      this.satMaterial = new MeshLambertMaterial({ color: 'palegreen', transparent: true, opacity: 0.7 });
      this.world.objectThreeObject(() => new Mesh(this.satGeometry, this.satMaterial));
  
      this.loadSat(tleFile);
  
      widget.addPauseHandler(this.pauseHandler.bind(this))
      widget.addTickHandler(this.tickHandler.bind(this));
  
    }
  
    pauseHandler(paused){
      if(paused){
        this.unpausedfollowSatellite = this.followSatellite;
        this.followSatellite = -1;
      } else {
        this.followSatellite = this.unpausedfollowSatellite;
      }
    }

    setFollowSatellite(satelliteIndex){
      this.unpausedfollowSatellite = satelliteIndex;
      this.followSatellite = satelliteIndex;
    }

    tickHandler(simTime, lastSimTime){
  
      if(this.satsById) {
  
        // Update TLEs
        const gmst = satellite.gstime(simTime);
        this.satsById.forEach(sat => {
  
          let currentTLE = sat.tles.find(element => {
            return Util.ms2us(Util.getUnixFromJulian(element.jdsatepoch)) > simTime.getTime();
          });
          if (!currentTLE) {
            currentTLE = sat.tles.at(-1);
          }
          const eci = satellite.propagate(currentTLE, simTime);
          if (eci.position) {
            const gdPos = satellite.eciToGeodetic(eci.position, gmst);
            sat.lat = satellite.radiansToDegrees(gdPos.latitude);
            sat.lng = satellite.radiansToDegrees(gdPos.longitude);
            sat.alt = gdPos.height / EARTH_RADIUS_KM
          }
        });
  
        // Update satelite
        this.world.objectsData(this.satsById);
  
        // Set view above satelite
        if(this.followSatellite >= 0) {
          let sat = this.satsById[this.followSatellite];
          this.world.pointOfView({
            lat: sat.lat,
            lng: sat.lng
          });
        }
  
      }
  
    }

    clear(){
      this.satsById = undefined;
      this.world.objectsData([]);
    }

    loadSat(filename) {
  
      fetch(filename).then(r2 => r2.text()).then(rawData => {
  
        const tleData = rawData.replace(/\r/g, '')
          .split(/\n(?=[^2])/)
          .filter(d => d)
          .map(tle => tle.split('\n'));
        let satData = [];
  
        tleData.forEach(tle => {
          satData.push(satellite.twoline2satrec(...tle))
        });
  
        this.satsById = Object.values(satData.reduce((ids, sat) => {
          const { satnum } = sat;
          ids[satnum] = ids[satnum] ?? { tles: [] };
          ids[satnum].tles.push(sat);
          return ids;
        }, {}));
  
      });
  
    }
  
  }
  
  